import "@/App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Header } from "@/components/Header";
import Landing from "@/pages/Landing";
import Inquiries from "@/pages/Inquiries";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import BlogCategory from "@/pages/BlogCategory";
import BlogAdmin from "@/pages/admin/BlogAdmin";
import BlogEditor from "@/pages/admin/BlogEditor";

function Shell() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/category/:slug" element={<BlogCategory />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route
          path="/inquiries"
          element={
            <ProtectedRoute ownerOnly>
              <Inquiries />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/blog"
          element={
            <ProtectedRoute ownerOnly>
              <BlogAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/blog/new"
          element={
            <ProtectedRoute ownerOnly>
              <BlogEditor />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/blog/:id/edit"
          element={
            <ProtectedRoute ownerOnly>
              <BlogEditor />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App bg-[#EFEBDE] min-h-screen">
        <div className="grain-overlay" aria-hidden="true" />
        <Shell />
        <Toaster position="bottom-right" theme="light" />
      </div>
    </AuthProvider>
  );
}

export default App;
